if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            // Swym re-init here (BEST PLACE)
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            //standard popup js
            const popupLinks = document.querySelectorAll(".product_standards-item-popup");
            const modal = document.getElementById("product_standard-modal");
            const modalTitle = document.getElementById("product_modal-title");
            const modalDesc = document.getElementById("product_modal-description");

            popupLinks.forEach(link => {
              link.addEventListener("click", function (e) {
                e.preventDefault();
                const name = this.dataset.standardName;
                const match = window.productStandards.find(s => s.standard_name === name);
                if (match) {
                  modalTitle.textContent = match.standard_name;
                  modalDesc.innerHTML = (match.standard_description || 'No description available.').replace(/\n/g, '<br>');
                  modal.classList.remove("hidden");
                  document.querySelector('.product_standard-modal-overlay').classList.remove("hidden");
                  // document.querySelector('body').classList.add("overflow-hidden");
                }
              });
            });
            if (document.querySelector(".product_close-popup")) {
              document.querySelector(".product_close-popup").addEventListener("click", () => {
                modal.classList.add("hidden");
                // document.querySelector('body').classList.remove("overflow-hidden");
              });
            }
            if (document.querySelector(".product_standard-modal-overlay")) {
              document.querySelector(".product_standard-modal-overlay").addEventListener("click", () => {
                modal.classList.add("hidden");
                document.querySelector('.product_standard-modal-overlay').classList.add("hidden");
                // document.querySelector('body').classList.remove("overflow-hidden");
              });
            }
            //product meta tabbing
            document.querySelectorAll('.product_tab-wrapper-top li').forEach(function (tab) {
              tab.addEventListener('click', function () {
                var tabId = this.getAttribute('data-tab');
                var wrapper = this.closest('.product_tab-wrapper');
                wrapper.querySelectorAll('.product_tab-wrapper-top li').forEach(function (tabItem) {
                  tabItem.classList.remove('active');
                });
                wrapper.querySelectorAll('.product_tab-wrapper-content').forEach(function (content) {
                  content.classList.remove('active');
                });
                this.classList.add('active');
                document.querySelectorAll(`.product_tab-wrapper-content[data-tab="${tabId}"]`).forEach(function (content) {
                  content.classList.add('active');
                });
              });
            });
            //standard popup js

            const selected = document.querySelector('.quick-add-modal__content-info .bulk-purchase-selected');
            const options = document.querySelector('.quick-add-modal__content-info .bulk-purchase-dropdown-options');
            const input = document.querySelector('.quick-add-modal__content-info .bulk-container #Quantity-bulk');
            // if (!selected || !options || !input) return;

            // Toggle dropdown on click
            if (selected) {
              selected.addEventListener('click', (e) => {
                e.stopPropagation();
                selected.classList.toggle('active');
                options.classList.toggle('show');
              });

              // Handle selecting an option
              options.querySelectorAll('.quick-add-modal__content-info .bulk-purchase-dropdown li').forEach(option => {
                option.addEventListener('click', () => {
                  const value = option.getAttribute('data-value');
                  const priceElement = option.querySelector('.bulk-purchase-dropdown-price');
                  if (!priceElement) return;
                  const priceSpan = priceElement.querySelector('.pp');
                  const priceData = priceSpan ? priceSpan.getAttribute('data-price') : null;
                  const priceValue = priceElement.innerHTML;
                  selected.querySelector('.bulk-purchase-dropdown-qty').textContent = value;
                  selected.querySelector('.bulk-purchase-dropdown-price').innerHTML = priceValue;
                  input.value = value;

                  options.classList.remove('show');
                  selected.classList.remove('active');
                  const priceTarget = document.querySelector('.product-form__submit .price__container .price-item--regular');
                  if (priceTarget && priceData) {
                    priceTarget.textContent = priceData;
                  }
                });
              });

              // Close dropdown when clicking outside
              document.addEventListener('click', function (event) {
                const isClickInside = selected.contains(event.target) || options.contains(event.target);
                if (!isClickInside) {
                  options.classList.remove('show');
                  selected.classList.remove('active');
                }
              });
            }

            //waitlist popup js
            const waitlist_popupLinks = document.querySelectorAll(".product__join-waitlist-btn");
            const waitlist_modal = document.querySelector(".block_join-waitlist-popup");
            if (waitlist_modal) {
              waitlist_popupLinks.forEach((link) => {
                link.addEventListener("click", function (e) {
                  e.preventDefault();
                  waitlist_modal.classList.remove("hidden");
                  document
                    .querySelector(".block_join-waitlist-popup-overlay")
                    .classList.remove("hidden");
                });
              });
              document
                .querySelector(".block_join-waitlist_close-popup")
                .addEventListener("click", () => {
                  waitlist_modal.classList.add("hidden");
                  document
                    .querySelector(".block_join-waitlist-popup-overlay")
                    .classList.remove("hidden");
                });
              document
                .querySelector(".block_join-waitlist-popup-overlay")
                .addEventListener("click", () => {
                  waitlist_modal.classList.add("hidden");
                  document
                    .querySelector(".block_join-waitlist-popup-overlay")
                    .classList.add("hidden");
                });
            }
            //waitlist popup js
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}